export default "__VITE_ASSET__CqZqGLBA__"